export default __webpack_public_path__ + "static/media/clear-icon.9b3ca0a0.svg";